@if (customerCompany) {
  <app-content-header [historyBack]="false" (backEvent)="onBack()" [headline]="customerCompany?.name"></app-content-header>
  <div class="h3 mb-3">{{ 'customer_details_headline' | i18next }}</div>
  <app-customer-navigation [id]="customerId"></app-customer-navigation>
  <div class="card card-nb">
    <div class="card-body">
      <h3>{{'payment_details_form_header' | i18next}}</h3>
      <app-sepa-form [bankAccount]="bankAccount" (formSubmit)="onUpdate($event)"></app-sepa-form>
    </div>
  </div>
}
